import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import type { AuthModel } from '../auth.model';
import type { AuthModuleData } from '@/domain/types';
@injectable()
export class AuthModelImpl extends AbstractModel<AuthModuleData> implements AuthModel {
  _modelData: AuthModuleData = {
    isShare: false,
    isLogin: false,
    ownerName: '',
    ownerId: '',
    canCopy: false,
    canCreateShare: false,
  };

  // eslint-disable-next-line no-useless-constructor
  constructor() {
    super();
  }

  public updateModuleData(getUpdateModuleValue: (value: AuthModuleData) => AuthModuleData) {
    this.update(getUpdateModuleValue);
  }
}
